import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import {
  LIVE_SHOP_CHAT_HEADER_HEIGHT,
  LIVE_SHOP_CHAT_IFRAME_MIN_HEIGHT,
} from '../../../catalogLiveShop.utils';

interface LiveShopMessagesProps {
  isPanelOpen: boolean;
  liveChatUrl: string;
}

const LiveShopMessages = ({ isPanelOpen, liveChatUrl }: LiveShopMessagesProps) => {
  const { translate } = useTranslation();
  const [isMessagesOpen, setIsMessagesOpen] = useState(false);
  const toggleMessages = () => setIsMessagesOpen((current) => !current);

  return (
    <Stack
      sx={(theme) => ({
        flex: isMessagesOpen ? 1 : 'none',
        minHeight: 0,
        border: 1,
        borderColor: theme.palette.custom.border.secondary,
        borderRadius: `${theme.shape.borderRadius2xl}px`,
        overflow: 'hidden',
      })}
    >
      <Stack
        direction="row"
        sx={{ alignItems: 'center', gap: 0.75, px: 1.75, py: 0.75, flexShrink: 0 }}
      >
        <Stack
          direction="row"
          onClick={toggleMessages}
          sx={{ flex: 1, minWidth: 0, alignItems: 'center', cursor: 'pointer' }}
        >
          <Typography variant="body2" noWrap sx={{ color: 'text.primary' }}>
            {translate(LangEnum.CATALOG_LIVE_SHOP_MESSAGES)}
          </Typography>
        </Stack>
        <IconButton
          icon={isMessagesOpen ? ChevronUp : ChevronDown}
          size="medium"
          ariaLabel={translate(LangEnum.GLOBAL_SECTION_TOGGLE)}
          onClick={toggleMessages}
        />
      </Stack>
      {isMessagesOpen && (
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', position: 'relative' }}>
          {isPanelOpen && (
            <iframe
              src={liveChatUrl}
              title={translate(LangEnum.CATALOG_LIVE_SHOP_MESSAGES)}
              referrerPolicy="strict-origin-when-cross-origin"
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                height: `max(calc(100% + ${LIVE_SHOP_CHAT_HEADER_HEIGHT}px), ${LIVE_SHOP_CHAT_IFRAME_MIN_HEIGHT}px)`,
                width: '100%',
                border: 0,
                display: 'block',
                colorScheme: 'light',
              }}
            />
          )}
        </Box>
      )}
    </Stack>
  );
};

export default LiveShopMessages;
